import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import {
  BusinessCreditReport,
  businessCreditReportTypes,
} from '../../../../../common/order/businessCreditReport'
import classes from './index.module.scss'
import { externalLink } from '../../../../../../configs/externalLink'
import { useSelector } from 'react-redux'

export const BlockBusinessCreditReport = () => {
  const locale = useSelector((state) => state.i18n.locale)

  const onClick = () => {
    window.open(externalLink.BUSINESS_CREDIT_SERVICE_DETAILS[locale], '__blank')
  }

  const renderReportHeader = () => {
    return (
      <Element
        elementName="div"
        style={{ backgroundColor: '#F3F3F3' }}
        className={classes.reportHeader}
      >
        <div
          className={[
            'dFlex justifyContentBetween',
            classes.reportHeaderTitle,
          ].join(' ')}
        >
          <Element
            elementName="span"
            style={{ fontSize: 20 }}
            className="fw600"
          >
            <Translate value="domesticSearchPreview.BUSINESS_CREDIT_REPORT" />
          </Element>
          <Element
            elementName="span"
            style={{ color: '#2C73E8' }}
            className="fw400 cursorPointer"
            onClick={onClick}
          >
            <Translate value="domesticSearchPreview.SERVICE_DETAIL" />
          </Element>
        </div>
        <Translate value="domesticSearchPreview.BUSINESS_CREDIT_REPORT_DESCRIPTION" />
      </Element>
    )
  }

  return (
    <Element style={{ border: '1px solid #d5d5d5' }}>
      {renderReportHeader()}
      <BusinessCreditReport type={businessCreditReportTypes.PREVIEW} />
    </Element>
  )
}
